//code from custom-component.js
$(document).ready(function () {
    $feedbackLinks = $('.leave-feedback-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function () {
        var locationName = $(this).attr('data-location-name') || '',
            $modalHeading = $('#leaveFeedbackHeader'),
            headingText = $modalHeading.text().replace('{{LocationName}}', locationName);
        $('#leaveFeedbackHeader').text(sanitizeHtmlStrings(headingText));
    });
});

// Analytics Locator details
analytics.eventConfig.push({
    "target": ".station-locator-details",
    "codeId": "lclsd",
    "events": [
        {
            "eventTarget": "a[href^='mailto'], a[href^='tel']",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "lclsd",
                "componentName": "locator contact link station details",
                "eventType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "location click to email"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('tel')",
                        "value": "location click to call"
                    }
                ],
                "elementType": [
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "'email link"
                    },
                    {
                        "rule": "$(context).attr('href').toLowerCase().startsWith('tel')",
                        "value": "phone number link"
                    }
                ],
                "searchType": "retailgasstations",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".station-locator-options .btn-primary",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "lgdsd",
                "componentName": "locator get directions station details",
                "eventType": "get directions outbound click",
                "elementType": "get directions button",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "retailgasstations",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".station-locator-options .btn-secondary",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "lfssd",
                "componentName": "locator find station station details",
                "eventType": "find station internal navigation click",
                "elementType": "find station button",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "retailgasstations",
                "titleText": ""
            }
        },
        {
            "eventTarget": ".btn-direction-loc a.btn-secondary.btn-station-detail",
            "eventType": "click",
            "tags": {
                "event": "locator",
                "componentId": "lgdsd",
                "componentName": "locator get directions station details",
                "eventType": "get directions outbound click",
                "elementType": "get directions button",
                "elementText": "",
                "destinationUrl": "",
                "searchType": "retailgasstations",
                "titleText": ""
            }
        },
        {
            "eventTarget": "a.leave-feedback-link",
            "eventType": "click",
            "tags": {
                "componentId": "llf",
                "componentName": "locator leave feedback",
                "elementText": "",
                "elementType": "leave feedback button",
                "event": "locator",
                "eventType": "location leave feedback click",
                "searchType": "",
                "titleText": "",
                "destinationUrl": "",
            }
        },
    ]
})